import { render } from "./MenuMobileGrade.vue?vue&type=template&id=4f32a0cc&scoped=true&ts=true"
import script from "./MenuMobileGrade.vue?vue&type=script&lang=ts"
export * from "./MenuMobileGrade.vue?vue&type=script&lang=ts"

import "./MenuMobileGrade.vue?vue&type=style&index=0&id=4f32a0cc&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f32a0cc"]])

export default __exports__